<template>
  <v-container id="regular-tables" fluid class="mt-5" tag="section">
    <v-card outlined max-height="100%">
      <v-simple-table fixed-header max-height="73vh">
        <thead>
          <tr>
            <th v-for="(name,index) of columns" :key="index" :class="columns.length === index+1? 'text-center':''" class="white--text light-blue darken-1">{{name}}</th>
          </tr>
        </thead>

        <tbody>
          <template v-if="paginatedData.length > 0">
            <tr v-for="(lineData,index) of paginatedData" :key="index">
              <td v-if="switchParam" >
                 <v-checkbox v-model="lineData.spotlight" :readonly="lineData.spotlight" @mousedown="alterSwitch(lineData.id)"></v-checkbox>
              </td>
              <td :style="`width:${line.width}%;`" v-for="(line,index) of lineData.lines" :key="index" v-text="line.name"></td>
              <td> <buttons-actions @action="action($event,lineData.id)" :actionsOptions="actionsOptions" /></td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td>Nenhum registro encontrado.</td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
      <div class="text-center pt-3 pb-3" v-if="totalPages > 1">
        <v-pagination v-model="page" :length="totalPages" circle></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Tables",
  components:{
    ButtonsActions: ()=> import('./ButtonsActions')
  },
  props: {
    title: String,
    columns: Array,
    linesData: Array,
    actionsOptions:Array,
    itemsPerPage:{
      type:Number,
      default:10
    },
    switchParam:{
      value:Boolean,
      default:false
    }
  },
  data: () => ({
    radioGroup:null,
    page: 1
  }),
  computed: {
    totalPages() {
      return Math.ceil(this.linesData.length / this.itemsPerPage) || 1;
    },
    paginatedData() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.linesData.slice(start, end);
    }
  },
  methods:{
    action($event, id){
     const params = {
       id:id,
       type:$event
     }

     this.$emit('action', params)
    },
    alterSwitch(id){
     this.linesData.forEach(element => {
        if(element.id !== id && !element.spotlight){
          element.spotlight = false
        }else{
          element.spotlight = true
        }
     });

     this.$emit('spotlight', id)

  }
  },
   

};
</script>

<style lang="sass" scoped>
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td
    word-break: break-all !important
</style>